import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { useEffect, useState } from "react";

export interface NumberProps {
  val: number;
  data: TableCol["data"];
  options: any;
  row: any;
  colKey: string;
  onChange: (item: any, options?: any) => void;
  withBorder?: boolean;
}
export default function Number(props: NumberProps) {
  const { val, colKey, row, options, withBorder } = props;
  const max = options?.max;
  const min = options?.max;
  const editable = options?.editable;
  const type = options?.type || "number-native";
  const style = options?.style || {};
  const [value, setValue] = useState(val);
  let onChange = props.onChange;
  if (options && options.onChange) onChange = options.onChange;

  useEffect(() => setValue(val), [val]);

  function handleChange(val?: string | number) {
    val !== null && val !== undefined && setValue(typeof val === "number" ? val : parseFloat(val));
  }

  function handleBlur() {
    if (value !== val) {
      let res = { ...row };
      res[colKey] = value;
      onChange(res, { row, options });
    }
  }
  if (!editable) return <span>{value}</span>;
  else
    return (
      <BasicTextInput
        {...{ type, max, min }}
        val={value}
        onChange={handleChange}
        onBlur={handleBlur}
        type={"quantity"}
        style={{
          color: "#1A1919",
          direction: "ltr",
          ...(!withBorder && { border: "none" }),
          minWidth: 100,
          padding: "4px 0px",
          ...style,
        }}
      />
    );
}
